<template>
    <div style="display: flex; overflow: hidden; height: 100vh">
        <SiderLayer />
        <main class="subpage usermap">
            <section class="title__content">
                <div class="subpage__inner">
                    <div v-show="isStudy" class="flex justify-between">
                        <h2 class="title">내위치</h2>
                        <CusButton :type="471" :label="`작품별 보기`" @onReturn="onContents" />
                    </div>
                    <div v-show="!isStudy" class="flex justify-between">
                        <h2 class="title">작품별 보기</h2>
                        <CusButton :type="470" :label="`학습 기록 보기`" @onReturn="onContents" />
                    </div>
                </div>
            </section>
            <Contents v-if="!isStudy" />
            <UserMap v-if="isStudy" />
        </main>

        <!-- <main class="subpage usermap">
            <section class="title__content">
                <div class="subpage__inner">
                    <div v-show="isStudy" class="flex justify-between">
                        <h2 class="title">내위치</h2>
                        <CusButton :type="475" :label="`작품별 보기`" style="width: 550px" @onReturn="onContents" />
                    </div>
                    <div v-show="!isStudy" class="flex justify-between">
                        <h2 class="title">작품별 보기</h2>
                        <CusButton :type="470" :label="`학습 기록 보기`" style="width: 250px" @onReturn="onContents" />
                    </div>
                </div>
            </section>
            <Contents v-if="!isStudy" />
            <UserMap v-if="isStudy" />
        </main> -->
    </div>
</template>
<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import UserMap from '@/views/userMapMain/UserMap.vue';
import Contents from '@/views/userMapMain/Contents.vue';
import CusButton from '@/components/widget/CusButton.vue';

import { getKnowledgeMap } from '@/api/modules/user_map.js';
import { getUserInfo } from '@/api/modules/mypage';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { monitoringLog } from '@/api/modules/monitoring';

// console.log('--userMapMain--30302');
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();

const isStudy = ref(true);
const noStudyData = ref(false);
// watch(noStudyData, (nnn, ooo) => {
//     console.log('--noStudyData noStudyData--', nnn);
// });
const isDisableBtn = ref(false);
const totalData = ref([]);
const todayStudy = ref();
const startSP = ref(null);
const curSP = ref(null);
const validAcad = computed(() => {
    return `${process.env.NODE_ENV}`;
});

const userName = ref();
const setUserInfo = async () => {
    const res = await getUserInfo(gStore.token);
    if (res && res.status === 200) {
        // console.log('--setUserInfo setUserInfo--');
        userName.value = res.data.data.studentName;
    }
};

const setGraphData = (spInfo) => {
    // const total = 3 * 96;
    // startSP.value = (spInfo.orgSpLevel - 1) * 96 + spInfo.orgSpLesson;
    // startSP.value = Math.round((100 / total) * point);
    // curSP.value = (spInfo.currentLevel - 1) * 96 + spInfo.currentLesson;
    startSP.value = { level: spInfo.orgSpLevel, lesson: spInfo.orgSpLesson };
    if (spInfo.currentLevel > 3) {
        // 4레벨 넘어가면 마지막 레벨레슨으로 표기
        curSP.value = { level: 3, lesson: 96 };
    } else curSP.value = { level: spInfo.currentLevel, lesson: spInfo.currentLesson };
};
const setStudyData = async () => {
    const resMap = await getKnowledgeMap(gStore.token);
    // console.log('--resMap-- :', resMap);
    if (resMap)
        if (resMap.status === 200) {
            //NoData 오늘학습
            noStudyData.value = resMap.data.data.list.length < 1;
            // console.log('-- resMap.data.data.list.length -- :', resMap.data.data.list.length);

            // 오늘학습
            todayStudy.value = structuredClone(resMap.data.data.todayLearning);
            // 그래프
            setGraphData(resMap.data.data.spInfo);

            // 정렬
            totalData.value = resMap.data.data.list
                .map((e) => {
                    return { ...e, date: Number(e.date.replaceAll('.', '')) };
                })
                .sort((a, b) => b.date - a.date)
                .map((e, i, arr) => {
                    // console.log('--totalData--e:', e);
                    const previous = arr[i - 1];
                    // const result = { ...e, date: previous && previous.date === e.date ? null : e.date.toString().slice(0, 4) + '.' + e.date.toString().slice(4, 6) + '.' + e.date.toString().slice(6, 8) };
                    // console.log('--totalData--result:', result);
                    // return result;
                    return { ...e, date: previous && previous === e.date ? null : e.date.toString().slice(0, 4) + '.' + e.date.toString().slice(4, 6) + '.' + e.date.toString().slice(6, 8) };
                });

            // .map((e,i)=>{
            // });
            // totalData.value = Object.keys(aa).map((key) => aa[key]);
        }
};

onMounted(() => {
    setUserInfo();
    setStudyData();

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('userMapMain monitoringLog API response ===', res);
    });
});

////////////////////////////----OnClick----////////////////////////////
const onContents = () => {
    isStudy.value = !isStudy.value;
    // router.push('/contents');
};
const onHome = () => {
    router.push('/learninghome');
};
</script>

<style scoped lang="scss">
.textLayout {
    margin: 0 2.5vmin;

    &.mapTt33 {
        margin: 0.83vmin 2.5vmin 1.33vmin;
    }
}
.roundedBtnOut {
    padding: 1.17vmin 3.33vmin;
    border-radius: 1.3vmin;
    border: 1px solid black;
    background-color: white;
}
.map__title {
    margin-top: 2vmin;
}

.content__box {
    margin-bottom: 6.42vmin;
}
.usermap {
    overflow-y: scroll;
    overflow-x: hidden;
}
</style>
